import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GroupCatalogsState } from './group-catalogs.models';

export const selectGroupCatalogsState = createFeatureSelector<GroupCatalogsState>('groupCatalogs');

export const selectGroupsCatalog = createSelector(selectGroupCatalogsState, (state) => state.groups);

export const selectGroupsCatalogLoading = createSelector(selectGroupCatalogsState, (state) => state.loading);

export const selectGroupsCatalogError = createSelector(selectGroupCatalogsState, (state) => state.error);
